const countryCodes = () => {
  return [
    { label: 'MX', value: '+52' },
    { label: 'US', value: '+1' },
    { label: 'IN', value: '+91' },
  ];
}

export default countryCodes;